<template>
    <div class="slider" >
        <section class="slider">
    <div class="flexslider" >
        <ul class="slides">
            <el-carousel :interval="5000" arrow="always">
                <el-carousel-item v-for="(li, slideIndex) in itemList" :key="slideIndex">
                    <div class="all">
                        <div class="ban" v-for="(item, itemIndex) in li.list" :key="itemIndex">
                            <div class="ban-in ban-grid">
                                <router-link :to="'/game/'+item.path" :title="item.title" target="_blank">
                                  <img class="null" src="static/images/topslide/null.png" alt="">
                                  <el-image class="img-responsive" :src="imgUrl('static/images/topslide/'+item.path)" :alt="item.title">
<!--                                    <div slot="placeholder" class="img-placeholder slide">-->
<!--                                      图片加载中<span class="dot">...</span>-->
<!--                                    </div>-->
                                  </el-image>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </ul>

    </div>

        </section>
    </div>
</template>

<script>
import imageExt from '@/mixins/imageExt'

export default {
  name: 'Slider',
  mixins: [imageExt],
  components: {},
  data() {
    return {
      itemList: []
    }
  },
  created() {
    this.getData()
  },
  activated() {
    this.getData()
  },
  methods: {
    getData() {
      const timeStamp = new Date().getTime()
      this.$http.get('static/data/home_slider.json' + '?' + timeStamp).then(res => {
        this.itemList = res.data
      },
      res => {
        console.log('error')
      }
      )
    }
  }

}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
